<template>
    <router-view></router-view>
</template>
<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
export default {
    setup() {
        const store = useStore();

        const darkMode = computed(() => store.state.app.darkMode);

        if (darkMode.value == 'dark') {
            document.documentElement.classList.add('dark');
        }

        const debounce = (callback, delay) => {
            let tid = null;
            return function (...args) {
                const ctx = self;
                tid && clearTimeout(tid);
                tid = setTimeout(() => {
                    callback.apply(ctx, args);
                }, delay);
            };
        };

        const _ = window.ResizeObserver;
        window.ResizeObserver = class ResizeObserver extends _ {
            constructor(callback) {
                callback = debounce(callback, 20);
                super(callback);
            }
        };
    }
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
}
html,
body,
#app {
    height: 100%;
    width: 100% !important;
    user-select: none;
}
.el-input__inner {
    text-align: left !important;
}
.el-cascader__tags {
    flex-wrap: nowrap !important;
}
</style>
